import { useLazyQuery } from "@apollo/client";

import { AddressPredictionsQuery, AddressPredictionsQueryVariables } from "@ctypes";
import { ADDRESS_PREDICTIONS } from "@graphql";

export const useFetchPlaceId = () => {
  const [fetchPlaceIdQuery, props] = useLazyQuery<
    AddressPredictionsQuery,
    AddressPredictionsQueryVariables
  >(ADDRESS_PREDICTIONS);

  const fetchPlaceId = async (address: string) => {
    try {
      const { data } = await fetchPlaceIdQuery({
        variables: { input: address },
      });
      return data?.addressPredictions?.predictions?.[0];
    } catch {}
    return null;
  };

  return [fetchPlaceId, props] as const;
};
